import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const MAP_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.7464158573246!2d-66.27004008478!3d18.458802974463215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c036f12c1b7e26f%3A0x4a1dfe7c59f5f5f5!2sDorado%2C%20Puerto%20Rico!5e0!3m2!1sen!2sus!4v1234567890123';

export const ContactInfoSidebar = () => (
  <div className="space-y-8">
    <div>
      <h2 className="text-3xl font-semibold text-stone-900 mb-6">
        Información de contacto
      </h2>
      <div className="space-y-4">
        <div
          className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex items-start gap-4"
          data-testid="contact-info-card-contact-ubicacion"
        >
          <div className="flex-shrink-0"><MapPin className="w-6 h-6 text-[#43b6b8]" /></div>
          <div>
            <h3 className="font-semibold text-stone-900 mb-1">Ubicación</h3>
            <p className="text-stone-700">Dorado, Puerto Rico</p>
          </div>
        </div>

        <div
          className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex items-start gap-4"
          data-testid="contact-info-card-contact-telefono"
        >
          <div className="flex-shrink-0"><Phone className="w-6 h-6 text-[#43b6b8]" /></div>
          <div>
            <h3 className="font-semibold text-stone-900 mb-1">Teléfonos</h3>
            <p className="text-sm text-stone-600 mb-1">Teléfono 1:</p>
            <a href="tel:+17873625354" className="text-stone-700 hover:text-[#43b6b8] transition-colors block mb-2">
              (787) 362-5354
            </a>
            <p className="text-sm text-stone-600 mb-1">Teléfono 2:</p>
            <a href="tel:+17873625352" className="text-stone-700 hover:text-[#43b6b8] transition-colors block">
              (787) 362-5352
            </a>
          </div>
        </div>

        <div
          className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex items-start gap-4"
          data-testid="contact-info-card-contact-email"
        >
          <div className="flex-shrink-0"><Mail className="w-6 h-6 text-[#43b6b8]" /></div>
          <div>
            <h3 className="font-semibold text-stone-900 mb-1">Email</h3>
            <a href="mailto:info@riseandshinezone.com" className="text-stone-700 hover:text-[#43b6b8] transition-colors">
              info@riseandshinezone.com
            </a>
          </div>
        </div>

        <div
          className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex items-start gap-4"
          data-testid="contact-info-card-contact-horario"
        >
          <div className="flex-shrink-0"><Clock className="w-6 h-6 text-[#43b6b8]" /></div>
          <div>
            <h3 className="font-semibold text-stone-900 mb-2">Horario</h3>
            <ul className="space-y-1 text-stone-700 text-sm">
              <li><span className="font-medium">Lunes y miércoles:</span> 8:00 a. m. – 2:15 p. m.</li>
              <li><span className="font-medium">Martes y jueves:</span> 8:00 a. m. – 1:30 p. m.</li>
              <li><span className="font-medium">Viernes:</span> Horario administrativo (no hay clases)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h2 className="text-3xl font-semibold text-stone-900 mb-6">
        Nuestra ubicación
      </h2>
      <div className="rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] h-[400px]" data-testid="google-maps">
        <iframe
          src={MAP_EMBED_URL}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ubicación de Rise & Shine Learning Zone"
        ></iframe>
      </div>
    </div>
  </div>
);
